import {usePixiRenderOnChange, usePlayers} from '@glark-newco/game-library';
import {Container, Graphics, Sprite} from '@pixi/react';
import {GlowFilter} from 'pixi-filters';
import {Assets, Rectangle} from 'pixi.js';
import {useCallback, useEffect, useMemo, useState} from 'react';
import {ROPE_COIL} from '../assetManifest';
import {useClearActiveEdit, useIsLinkCreationActive, useStartLinkCreation} from '../state/networkEditStore';
import {useWasSpareRopeUsed} from '../state/spareRopeSlice';

const glowBlue = new GlowFilter({distance: 20, outerStrength: 5, alpha: 1, color: 0x0d27a8});

const hitAreaCoords = {x: -12.5, y: -12.5, w: 100, h: 80};

export function RopeCoil() {
    const isLinkCreationActive = useIsLinkCreationActive();
    const spareRopeWasUsed = useWasSpareRopeUsed();
    const startLinkCreation = useStartLinkCreation();
    const {localPlayer} = usePlayers();
    const [hover, setHover] = useState(false);
    const clearLinkCreation = useClearActiveEdit();

    const debugHitArea = false;

    const handleEscape = useCallback((event: KeyboardEvent) => {
        if (event.key === 'Escape') {
            clearLinkCreation();
        }
    }, [clearLinkCreation]);

    useEffect(() => {
        if (isLinkCreationActive) {
            document.addEventListener('keydown', handleEscape);
        }
        return () => document.removeEventListener('keydown', handleEscape);
    }, [isLinkCreationActive, handleEscape]);

    const filters = useMemo(() => hover ? [glowBlue] : [], [hover]);
    usePixiRenderOnChange([filters]);

    if (spareRopeWasUsed) return;

    return (
        <>
            <Container
                interactive={true}
                key={ROPE_COIL}
                onmouseenter={() => setHover(true)}
                onmouseleave={() => setHover(false)}
                onclick={() => {
                    if (localPlayer.isFacilitator) {
                        startLinkCreation();
                    }
                }}
                anchor={0.5}
                x={1330}
                y={80}
                filters={filters}
                hitArea={new Rectangle(hitAreaCoords.x, hitAreaCoords.y, hitAreaCoords.w, hitAreaCoords.h)}
            >
                {debugHitArea && (<Graphics draw={g => g.clear().lineStyle({width: 2.5, color: 0x009900}).drawRect(hitAreaCoords.x, hitAreaCoords.y, hitAreaCoords.w, hitAreaCoords.h)}/>)}
                <Sprite scale={0.125} texture={Assets.get(ROPE_COIL)} />
            </Container>
        </>
    );
}
